<template>
  <el-card class="box-card mb-10" :loading="loading">
    <div
      id="utakhcChartContainer"
      :style="'min-height:500px;width:' + width || '100%'"
      ref="utakhcChartContainer "
    ></div>
  </el-card>
</template>
<script>
import ChartHelper from "@/mixins/ChartsHelper";
import Highcharts from "@/config/highcharts";

window.utakhcChart = null;

export default {
  props: ["utakhcData", "width"],
  mixins: [ChartHelper],
  data() {
    return {
      loading: false,
      mean: 7.14,
      stndDev: 2.1,
      cv: 1.2,
      chartData: {
        chart: {
          zoomType: "x",
          height: "500px",
        },
        scrollbar: {
          enabled: true,
          height: 10,
          showFull: false,
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
          enabled: false,
        },
        title: {
          text: "UTAK HC1",
        },
        subtitle: {
          text: "",
        },
        decimals: true,
        credits: {
          enabled: false,
        },

        yAxis: [
          {
            title: {
              text: "Concentration (ng/mL)",
            },
            allowDecimals: false,
            lineWidth: 2,
            gridLineWidth: 0,
            tickWidth: 2,
            min: 0,
            showEmpty: true,
            max: 1800,
            tickInterval: 250,
            labels: {
              style: {
                fontSize: "13px",
              },
            },
          },
        ],
        xAxis: {
          title: {
            text: "Analyte",
          },
          categories: [],
          tickWidth: 2,
          tickmarkPlacement: "on",
          minPadding: 10,
          labels: {
            rotation: 290,
            offset: 100,
            padding: 50,
            style: {
              fontSize: "13px",
              // whiteSpace: "nowrap"
              // textOverflow: "none"
            },
          },
          events: {
            afterSetExtremes: () => {},
          },
        },

        tooltip: {
          pointFormat: "X - {point.category} <br/>",
          footerFormat: "Y - {point.y} <br/>",
        },
        series: [
          {
            name: "Used",
            data: [],
          },
        ],
      },
    };
  },
  async mounted() {
    await this.prepareChartData();
  },
  methods: {
    prepareChartData() {
      this.loading = true;
      if (this.utakhcData.data) {
        let categories = this.utakhcData.data.map((e) => e.name);
        this.chartData.xAxis.categories = categories;

        this.chartData.xAxis.categories = this.utakhcData.data.map(
          (e) => e.name
        );
        let values1 = this.utakhcData.data.map((e) => e.value);
        this.chartData.series[0].data = values1;

        window.utakhcChart = Highcharts.chart(
          "utakhcChartContainer",
          this.chartData
        );
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss"></style>
